import { defaultExceptionType } from '@grafana/faro-core';
import { valueTypeRegex } from './const';
export function getValueAndTypeFromMessage(message) {
    var _a, _b;
    const groups = message.match(valueTypeRegex);
    const type = (_a = groups === null || groups === void 0 ? void 0 : groups[1]) !== null && _a !== void 0 ? _a : defaultExceptionType;
    const value = (_b = groups === null || groups === void 0 ? void 0 : groups[2]) !== null && _b !== void 0 ? _b : message;
    return [value, type];
}
//# sourceMappingURL=getValueAndTypeFromMessage.js.map